// Modal with title, detail copy, and actions (up to 3, at least 1)
import React, { useContext, useEffect, useRef } from 'react';
import { css } from '@emotion/react';
import {
  type RestModalForwards,
  type RestModalMultiCTATypeI,
} from '@bbkAdminUtils/api-client/rest-modals-cards-types';
import { cs } from '@bbkAdminUtils/css-utils';
import { type ReactFCC } from '@bbkAdminUtils/utility-types';
import CustomerHtml from '@bbkFunnelComponents/customer_html/customer_html';
import {
  ModalDesktopInnerSpacer,
  OfferTitleMobile,
  TitleTheme,
  useMediaQueries,
} from '@bbkFunnelComponents/modals/sections';
import { MultiCTAOtherActions } from '@bbkFunnelComponents/modals/v2/multi-cta-actions';
import { RefsContext } from '@bbkFunnelUtils/refs.context';

import './modal.scss';

type Props = {
  modalInfo: RestModalMultiCTATypeI;
  close: () => void;
  handleAction: (action: RestModalForwards) => void;
};

export const MultiCTATypeI: ReactFCC<Props> = (props) => {
  const {
    modalInfo: {
      id,
      requires: {
        info: { title, details },
        generic_actions = [],
      },
    },
    close,
    handleAction,
  } = props;
  const { mobileView, tabletView } = useMediaQueries();

  const refsPrefix = id;
  const refsCtx = useContext(RefsContext);
  const titleRef = useRef<HTMLSpanElement>(null);
  useEffect(() => refsCtx?.addRef(`${refsPrefix}-title`, titleRef), [titleRef]);
  const descRef = useRef<HTMLDivElement>(null);
  useEffect(() => refsCtx?.addRef(`${refsPrefix}-desc`, descRef), [descRef]);

  return (
    <ModalDesktopInnerSpacer
      css={css`
        display: grid;
        height: auto;
        ${tabletView && 'max-width: 750px; min-width: 500px'}
        ${mobileView && 'padding: 12px 1rem; flex: 1 1 auto;'}
      `}
      className={cs('multi-cta-type-I display-grid inner-spacer', {
        desktop: tabletView,
        mobile: mobileView,
      })}
    >
      <OfferTitleMobile
        title={<TitleTheme title={title} ref={titleRef} />}
        close={close}
      />
      <div
        css={css`
          overflow-y: auto;
        `}
        ref={descRef}
      >
        <CustomerHtml value={details} />
      </div>
      <div
        className="display-grid action-items"
        css={css`
          gap: 1rem;
          ${
            tabletView &&
            css`
              grid-template-columns: repeat(${generic_actions.length}, 1fr);
              grid-template-rows: auto;
            `
          }
        `}
      >
        <MultiCTAOtherActions
          id={id}
          actions={generic_actions}
          handleAction={handleAction}
        />
      </div>
    </ModalDesktopInnerSpacer>
  );
};
